import * as Sentry from "@sentry/react";
import { combineAppReducer } from "@dpdgroupuk/ai-app";

import { reducer as ownApp } from "./ownApp";
import { configureStore } from "@reduxjs/toolkit";
import { reducer as depot } from "./depot";
import { reducer as filters } from "./filters";
import { reducer as sorters } from "./sorters";
import { reducer as map } from "./map";
import { reducer as matrixProfile } from "./matrixProfile";
import { reducer as driverManagement } from "./driverManagement";
import { reducer as routeManagement } from "./routeManagement";
import { reducer as sectionManagement } from "./sectionManagement";
import { reducer as shiftManagerManagement } from "./shiftManagerManagement";
import { reducer as sources } from "./sources";
import { reducer as ownUser } from "./ownUser";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    if (action.type.includes("/rejected")) {
      return {
        ...action,
      };
    } else {
      return null;
    }
  },
  stateTransformer: (state) => {
    const { profile, selectedOverlay, type } = state.matrixProfile;
    const app = { ...state.ownApp };
    const map = { ...state.map };
    delete map.visiblePostcodes;
    return {
      map,
      app: app,
      matrixProfile: {
        profile,
        selectedOverlay,
        type,
      },
    };
  },
});

export default configureStore({
  reducer: combineAppReducer({
    ownApp,
    ownUser,
    filters,
    sorters,
    matrixProfile,
    driverManagement,
    routeManagement,
    sectionManagement,
    shiftManagerManagement,
    sources,
    depot,
    map,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
  devTools: false,
  enhancers: (getDefaultEnhancers) => [
    ...getDefaultEnhancers(),
    sentryReduxEnhancer,
  ],
});
